module.exports = __webpack_public_path__ + "static/sec7-bg-80c1ff0526ff1846cdd163ed888fca5a.jpg";